import { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";

interface CustomToggleProps {
    labelKey: string;
    name: string;
    value: boolean;
    errorKey: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const CustomToggle: FC<CustomToggleProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col">
            {props.labelKey && (
                <label
                    className="block mb-2 text-lg font-semibold text-light-text-200 dark:text-dark-text-400"
                    htmlFor={props.labelKey}
                >
                    {t(props.labelKey)}
                </label>
            )}
            <label className="inline-flex items-center cursor-pointer">
                <input
                    name={props.name}
                    type="checkbox"
                    value=""
                    className="fixed none sr-only peer"
                    checked={props.value}
                    onChange={props.onChange}
                />
                <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
            </label>
            <p className={`mt-1 ml-3 text-sm font-normal text-red-500`}>
                {props.errorKey ? t(props.errorKey) : props.name ? "\u00A0" : ""}
            </p>
        </div>
    );
};

export default CustomToggle;
